import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/student-loan',
  component: () => import('../../routes/StudentLoan.svelte'),
  card: {
    id: 'student-loan',
    title: 'Student Loan Repayment',
    description: 'Compare standard, income-driven, and refinance plans for your student loans.',
    icon: 'school',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/student-loan',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Student Loan Repayment Calculator – Compare Standard, IDR & Refinance Plans',
    description: 'Free student loan repayment calculator. Compare standard 10-year, income-driven repayment (IDR), and refinance plans side by side. See monthly payments, total interest, payoff timelines, and loan forgiveness amounts.',
  },
};

export default meta;
